export default __webpack_public_path__ + "static/media/Kunde.10be4a24.svg";